import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import styled from 'styled-components';
import FlipMove from 'react-flip-move';
import {connect} from 'react-redux';

import api from 'api';
import Container from 'partials/Container';
import WP from 'WP';
import Image from 'partials/Image';
import Filters from 'partials/Filters';
import css from 'css';
import HeadMeta from 'partials/HeadMeta';
import Loader from 'partials/Loader';
import {isIE} from 'helpers';

import {setCurrentView} from 'store';

class Employees extends Component {

    constructor() {
        super();

        this.state = {
            employees: [],
            activeFilters: [WP.trans.all],
            focusTarget: null
        }
    }

    componentWillMount() {
        this.mounted = true;

        if (!window.location.hash && this.props.currentView && !isIE()) {
            // hash set in <Filters> will trigger routhe change and restarts comp. lifecycle so we can quit here for now (we'll continue once hash is set)
            // NOTE: on IE and Edge changing hash does not trigger lifecycle restart so this DOES not apply for IE/Edge
            return;
        }

        this.props.setCurrentView({
            translation_paths: {
                no: '/' + WP.slugs.employees.no,
                en: '/' + WP.slugs.employees.en
            }
        });

        api.getEmployees()
            .then(resp => {
                if (resp.data[0]) {
                    //console.log('EMPLOYEES: ', resp.data);
                    if (this.mounted) this.setState({employees: resp.data});
                }
            })
            .catch(e => console.log(e));
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _filtered() {
        const {activeFilters, employees} = this.state;
        if (activeFilters.indexOf(WP.trans.all) !== -1) return employees;
        return employees.filter(empl => activeFilters.indexOf(empl.acf.location.name) !== -1);
    }

    _onFilter(names) {
        this.setState({activeFilters: names});
    }
    _toggleFocus(id){
        this.setState((prevState) =>{
            return {
                focusTarget: prevState.focusTarget !== id ? id : null
            }
        })
    }
    render() {
        return (
            <Wrapper>

                <HeadMeta
                    title={WP.trans.employees + ' - HLM'}
                    description=""
                    ogUrl=""
                    ogType=""
                    ogTitle=""
                    ogDescription=""
                    ogImage=""
                />

                <Filters title={WP.trans.employees || 'Folk'} onFilter={this._onFilter.bind(this)} taxonomy="offices"/>

                <Loader loaded={this.state.employees.length > 0}/>

                <GridWrapper>
                    <Container>
                        <Grid
                            duration={500}
                            easing="ease-out"
                            enterAnimation={{
                                from: {
                                    transform: 'translateY(100px)',
                                    opacity: 0.1,
                                },
                                to: {
                                    transform: '',
                                },
                            }}
                            leaveAnimation={{
                                from: {
                                    transform: '',
                                },
                                to: {
                                    transform: 'translateY(100px)',
                                    opacity: 0.1,
                                },
                            }}
                        >
                            {this._filtered.bind(this)().map(employee => (

                                <Employee key={employee.id}>
                                    <div onClick={() => this._toggleFocus(employee.id)} className={['image-info', employee.id === this.state.focusTarget ? 'focused' : ''].join(' ')}>
                                        <Image className={employee.acf.info && "image"} image={employee.acf.image} background ratio="140:99"/>
                                        {employee.acf.info &&
                                            <div>
                                                <span>{employee.acf.info}</span>
                                            </div>
                                        }
                                    </div>
                                    <h4>{employee.title.rendered}</h4>
                                    <footer>
                                        <div>
                                            <span>{employee.acf.job_title}</span>
                                            <div>
                                                <a href={'mailto:' + employee.acf.email}>{employee.acf.email}</a>
                                            </div>
                                            {employee.acf.phone &&
                                            <div>
                                                <a className="mail-link"
                                                   href={'tel:' + employee.acf.phone.replace(' ', '')}>{employee.acf.phone}</a>
                                            </div>
                                            }
                                            {employee.acf.twitter &&
                                            <div>
                                                <a href={'https://twitter.com/' + employee.acf.twitter}
                                                   target="_blank">Twitter</a>
                                            </div>
                                            }
                                            {employee.acf.linkedin &&
                                            <div>
                                                <a href={employee.acf.linkedin} target="_blank">Linkedin</a>
                                            </div>
                                            }
                                        </div>
                                        <span>{employee.acf.location.name}</span>
                                    </footer>
                                </Employee>
                            ))}
                        </Grid>
                    </Container>
                </GridWrapper>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentView: state.currentView
    }
}

const actions = {
    setCurrentView
}

export default connect(mapStateToProps, actions)(withRouter(Employees));

const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100% ;
`

const GridWrapper = styled.div`
    padding-top:90px;
`

const Grid = styled(FlipMove)`
    display:flex;
    flex-wrap: wrap;
    margin-left:-20px;
    margin-right:-20px;
    overflow: hidden;
`

const Employee = styled.section`
    
    border-right: 20px solid #F9F9F9;
    border-left: 20px solid #F9F9F9;
    
    width: 25%;
    margin-bottom:80px;
    background: #fff;
    .image-info{
        position: relative;
        .image,
        .image+div{
            transition: opacity .3s ease-in-out;
        }
        .image{
            z-index: 2;
        }
        .image+div{
            opacity: 0;
            position: absolute;
            top: 0;
            overflow: hidden;
            padding: 16px;
            span{
                transition: top .5s ease-in-out;                
                position: relative;
                font-family: ${css.fonts.bg_regular};
                font-size: 19px;
                line-height: 23px;                
            }       
             @media (min-width: 501px) and (max-width: 1280px) {               
               span{
                font-size: 15px;
               }
            }     
            @media (min-width: 501px) and (max-width: 650px) {
               padding: 10px;
               span{
                font-size: 12px;
               }
            }
        
        }                   
            }
            span:nth-child(1) {                
                top: -200px;  
            }
            span:nth-child(2) {
                top: 200px;  
            }     
        }
        @keyframes opacity {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
        .focused .image,
        .image:focus,
        .image:hover{
            opacity: 0;
            &+div{                
                opacity: 1;
                span{
                    opacity: 0;
                    top: 0;
                    animation-delay: .05s;
                    animation-name: opacity;
                    animation-duration: 1.25s;
                    animation-iteration-count: 1;
                    animation-fill-mode: forwards;    
                    animation-timing-function: linear;            
                }      
            }
        }
    }
        
    
    h4 {
        font-size:20px;
        padding: 25px 0 25px 16px;
        font-family: ${css.fonts.bg_bold};
    }
    footer {
        display:flex;
        justify-content: space-between;
        font-size:14px;
        color: #797979;
        padding: 0 16px 16px 16px;        
        a {
            &:hover {
                border-bottom: 1px solid #9e9e9e;
            }
        }
        > div > div {
            margin-bottom: 5px;
        }
        > div > span {
            display:inline-block;
            margin-bottom:5px;
            &:last-child {
                margin-top:5px;
            }
        }
        
        a{
            color: #000;
            border-bottom: 1px solid transparent;            
            &:hover {
                border-bottom: 1px solid #000;
            }
        }
         
        
    }
    @media (max-width: 980px) {
        width: 50%;
    }
    @media (max-width: 500px) {
        width: 100%;
    }
`



// WEBPACK FOOTER //
// ./src/views/Employees.js